<template>
    <SvgIcon
        width="32px"
        height="32px"
        :classes="setIconClasses()"
        icon="nearby"
    />
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "NearbyIcon",
    components: { SvgIcon },
    methods: {
        setIconClasses: function() {
            let str = "";
            if (this.$getState("useUserLocation")) str += "text-primary ";
            if (!this.$getState("useUserLocation")) str += "text-location ";
            return str;
        }
    }
};
</script>
